<template>
  <div class=" is-fullwidth">
    <div class="is-pulled-right"><select class="input" v-model="limit" >
      <option value="">Number of Orders</option>
      <option value="10">10 orders</option>  
      <option value="50">50 orders</option>  
      <option value="100">100 orders</option>  
      <option value="250">250 orders</option>  
      <option value="">Display All Orders</option>  
    </select></div>
    <div class="is-pulled-right"><input class="input" v-model="search" placeholder="search orders ..."/></div>
    <div class="buttons">
      
        <button class="button " v-bind:class="{'is-success': selected_location_id == row.id}" v-for="row in locations" :key="row.id" @click="selected_location_id = row.id">{{ row.name }}</button>
      
      
    </div>

    <table class="table is-hoverable is-fullwidth" id="orderstable">
    	<thead>
    		
        <th>PO Number</th>
   	 		<th>Customer</th>
          
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Garment</th>
          <th>Extras</th>
          <th>Qty</th>
          
          <th>Cutting</th>
          <th>Makeup Location</th>
          <th>&nbsp;</th>
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="11" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && orders.length == 0">
                <td colspan="11" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
         
               <td >{{order.ponumber}}
                <router-link :to="'/printing-cutting/bundling/' + order.orderID">
                <span class="icon" :class="{ 'has-text-success': order.bundles_created == 1, 'has-text-danger': order.bundles_created == 0}">
                 <i class="fa fa-barcode">&nbsp;</i>
               </span>
               </router-link>
              </td>
          <td>{{order.clientname}}</td>
           
          <td>{{order.deliverydate}}</td>
          <td>{{order.garmentname}}</td>
          <td>
            <div class="tags">
              <span class="tag is-success is-small" v-if="order.requires_embroidery==1">Embroidery</span>
              <span class="tag is-link is-small" v-if="order.requires_embossing==1">Embossing</span>
              <span class="tag is-link is-warning" v-if="order.requires_silicon_stripes==1">Silicon Stripes</span>
              <span class="tag is-link is-warning" v-if="order.requires_knitted_trim==1">Knitted Trims</span>
              <span class="tag is-link is-warning" v-if="order.requires_dtf==1">DTF</span>
              <span class="tag is-link is-warning" v-if="order.requires_gps_pockets==1">GPS</span>
              
            </div>
          </td>
          <td>{{ order.total_qty }}</td>
         
          <td>
<span class="icon has-text-success" v-if=" order.multiply_cutting == 1">
                <i class="fa fa-check"></i>
            </span>

          </td>
          <td>
              <div class="buttons has-addons ">
                <select class="select is-small" v-model="order.makeup_location_id">
                  <option value="">Makeup Location</option>
                  <option :value="row.id" v-for="row in makeuplocations" :key="row.id">{{ row.name }}</option>
                </select>
                <div v-if="false">
                <button class="button is-small " :class="{'is-success' : order.makeup_location_id==row.id}"  v-for="row in makeuplocations" :key="row.id" @click="order.makeup_location_id = row.id">{{ row.name }}</button>
                </div>
              </div>
          </td>
          <td>
              <button class="button is-success is-small" v-if="order.makeup_location_id > 0" @click="processOrder(order)" :disabled="working==true">Process</button>
          </td>
             
			</tr>
    	</tbody>
    </table>
    
    
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      multiply_orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      makeuplocations: [],
      locations: [],
      selected_location_id: 0,
      order_by: 'deliverydate ASC',
      search: '',
      limit: ''
    }
  },
   methods: {
      async getOrders() {
        this.loading=true
        OrderService.getAwaitingMakeupMultiplyOrders(this.accessToken, this.selected_location_id, this.limit, this.order_by)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      

    
    async processOrder(order) {
        this.working = true

        var order_id = order.orderID

        var formdata = { 
            _method: 'patch',
             ready_for_makeup : 1,
             makeup_location_id : order.makeup_location_id
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            order.ready_for_makeup = 1
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) {
            if(  u.ready_for_makeup == 0) 
            {
               console.log(u)
              return 1
            }
          })

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
          }

          return filteredOrders
       
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           //this.getMultiplyOrders();
           this.getLocations(1);
           this.getMakeupLocations();
        });
  },
 
  mounted() {
    if (localStorage.printing_limit) {
      this.limit = localStorage.printing_limit;
    }
    else{
      this.limit = ''
    }

    if (localStorage.printing_location_id) {
      this.selected_location_id = localStorage.printing_location_id;
    }
    else{
      this.selected_location_id = 1
    }
      
  },
   watch: {
    'selected_location_id'() {
      this.orders = []
      localStorage.printing_location_id = this.selected_location_id
      this.getOrders();
    },
    'limit'() {
      localStorage.printing_limit = this.limit
      this.orders = []
      this.getOrders();
    }
  }
}


</script>

<style scoped>
  td .tags span {text-decoration: none;}

</style>
